const { device, Modal } = window.od;

export default class ProductCustomisable {
	constructor() {
		this.bindEvents();
	}

	bindEvents() {
		document.addEventListener('click', e => this.doModalCheck(e));
	}

	doModalCheck(e) {
		if (e.target.hasAttribute('data-customisable') && this.modalRequired()) {
			e.preventDefault();

			const modalTarget = e.target.getAttribute('data-target');
			const targetUrl = e.target.getAttribute('href');

			this.triggerModal(modalTarget).then(modal =>
				this.setModalLink(modal.target, targetUrl),
			);
		}
	}

	triggerModal(modalTarget) {
		const modalInstance = new Modal(modalTarget);
		return modalInstance.show();
	}

	setModalLink(modal, url) {
		modal.querySelector('#customisableModalContinue').setAttribute('href', url);
	}

	modalRequired() {
		return device() !== 'lg';
	}
}
